import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, PhoneIcon, XIcon } from "lucide-react";
import { business, navLinks, routes } from "../../data/business";
import { Logo } from "../brand/Logo";
import { MagneticCallButton } from "../ui/MagneticCallButton";
import { buttonStyles } from "../ui/buttonStyles";
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [location.pathname]);
  return <header className={`sticky top-0 z-40 border-b transition-[background-color,border-color,box-shadow] duration-200 ease-out ${scrolled ? "border-gold/20 bg-navy/95 shadow-[0_8px_32px_-16px_rgba(0,0,0,0.6)] backdrop-blur-md" : "border-white/10 bg-navy"}`} data-id="element-367" data-mp="3ugwc0n274trg">
      <div className={`gutter flex items-center justify-between gap-6 transition-[padding] duration-200 ease-out ${scrolled ? "py-2.5" : "py-4"}`} data-id="element-368" data-mp="glhz2wz9vg8l">
        <Logo compact={scrolled} data-id="element-369" data-mp="lmnqmrh74xgj" />

        <nav aria-label="Primary" className="hidden 2xl:block" data-id="element-370" data-mp="3k2qdt7ypdzz3">
          <ul className="flex items-center gap-1" data-id="element-371" data-mp="3k4b6es1gj8ub">
            {navLinks.map(l => <li key={l.to} data-id="element-372" data-mp="3p1jqiy661my7">
                <NavLink to={l.to} end={l.to === "/"} className={({
              isActive
            }) => `relative whitespace-nowrap rounded-full px-4 py-2 text-[0.95rem] transition-colors duration-150 ${isActive ? "text-gold-soft" : "text-white/80 hover:text-white"}`} data-id="element-373" data-mp="3u0mmzu82ykuk">
                  {l.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-3" data-id="element-374" data-mp="35dtptdtnuq4x">
          <a href={business.payUrl} target="_blank" rel="noopener noreferrer" className={`${buttonStyles.outlineLight} hidden lg:inline-flex`} data-id="element-375" data-mp="35fehmvolbuz3">
            Post Bail Online
          </a>
          <MagneticCallButton size="md" className="hidden sm:inline-flex" data-id="element-376" data-mp="3eei4maqvouiv" />
          <a href={business.phoneHref} aria-label={`Call ${business.phoneDisplay}`} className="grid h-12 w-12 place-items-center rounded-full bg-gold text-navy transition-colors duration-150 hover:bg-gold-hover active:scale-95 sm:hidden" data-id="element-377" data-mp="2qpfleyglitm9">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-378" data-mp="2vn8p9kuffbjd" />
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? "Close menu" : "Open menu"} className="grid h-12 w-12 place-items-center rounded-full border border-white/20 text-white transition-colors duration-150 hover:border-gold-soft hover:text-gold-soft 2xl:hidden" data-id="element-379" data-mp="27xms12xm76e0">
            {open ? <XIcon className="h-5 w-5" data-id="element-380" data-mp="9h5jkil8koo9" /> : <MenuIcon className="h-5 w-5" data-id="element-381" data-mp="9hxd7nv9wcbw" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-382" data-mp="efpakxeosqnh">
        {open && <motion.nav id="mobile-nav" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="gutter border-t border-white/10 bg-navy pb-8 pt-4 2xl:hidden" data-id="element-383" data-mp="1251f3jz2kajg">
            <ul className="grid gap-1 sm:grid-cols-2 lg:grid-cols-3" data-id="element-384" data-mp="x7i0giyglvqz">
              {navLinks.map(l => <li key={l.to} data-id="element-385" data-mp="3hvwcozhgefu5">
                  <NavLink to={l.to} end={l.to === "/"} className={({
              isActive
            }) => `flex min-h-[52px] items-center rounded-xl px-4 font-serif text-xl transition-colors duration-150 ${isActive ? "bg-white/5 text-gold-soft" : "text-white hover:bg-white/5"}`} data-id="element-386" data-mp="3hw5zke77c6vm">
                    {l.label}
                  </NavLink>
                </li>)}
            </ul>
            <div className="mt-6 flex flex-wrap gap-3" data-id="element-387" data-mp="jy7yw4dgioo5">
              <a href={business.payUrl} target="_blank" rel="noopener noreferrer" className={buttonStyles.outlineLight} data-id="element-388" data-mp="fx60fprd6gn8">
                Post Bail Online
              </a>
              <NavLink to={routes.getBond} className={buttonStyles.outlineLight} data-id="element-389" data-mp="5zi4iwi0v33h">
                Start Online
              </NavLink>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}